export interface CorbisCreateCartBody {
    contexte: string;
    ihmAppelante: string;
    localisation: {
        adresse: {
            _type: string;
            codeINSEE: string;
            codePostal: string;
            codeRivoli: string;
            commune: string;
            hexaCleInterne: string;
            idAdresseByTel: string;
            voie: string;
            numero: string;
            imb: string;
        };
    };
    typeActeur: string;
    typeClient: string;
}

export const CorbisCreateCartBodyPY: CorbisCreateCartBody = {
    contexte: 'ACQUISITION',
    ihmAppelante: 'ECOMMERCE',
    localisation: {
        adresse: {
            _type: 'AdresseHorizontale',
            codeINSEE: '75120',
            codePostal: '75020',
            codeRivoli: '7899',
            commune: 'PARIS',
            hexaCleInterne: '7512022EXS',
            idAdresseByTel: '75120PY0RY00011',
            voie: 'RUE DE LA PY',
            numero: '25',
            imb: 'ID-75120000005K',
        },
    },
    typeActeur: 'CLIENT',
    typeClient: 'GP_PRO',
};

export interface CorbisUpdateCartBody {
    contexte: 'ACQUISITION';
    ihmAppelante: 'ECOMMERCE';
    localisation: {
        adresse: {
            _type: string;
            codeINSEE: string;
            codePostal: string;
            codeRivoli: string;
            commune: string;
            hexaCleInterne: string;
            idAdresseByTel: string;
            voie: string;
            numero?: string;
            imb?: string;
            residence?: string;
            batiment?: string;
            etage?: string;
            escalier?: string;
        };
        pointAcces: CorbisAccessPoint;
    };
    typeActeur: 'CLIENT';
    typeClient: 'GP_PRO';
}

export interface CorbisAccessPoint {
    ND?: string;
    NDRoutage?: string;
    statut?: string;
    statutAccesFTTH?: string;
    pto?: string;
}


export interface ICorbisCartApiResponse {
    contexte: string;
    dateExpiration: string;
    eligibiliteCommerciale: ICommercialEligibilityApi;
    eligibiliteTechnique: ITechnicalElibigilityApi;
    idPanier: string;
    ihmAppelante: string;
    localisation: ILocalisationApi;
    statut: string;
    typeActeur: string;
    typeClient: string;
}

export interface ICommercialEligibilityApi {
    offresPrincipales: IPrincipalOfferApi[];
    debitsReglementaires?: IRegulatoryFlowRates[];
}

export interface IRegulatoryFlowRates {
    debitDescendantMax: string;
    debitMontantMax: string;
    techno: string;
}

export interface IPrincipalOfferApi {
    idOffrePrincipale: string;
    idOffreRaccordement: string;
    offresSecondaires: ISecondaryOfferApi[];
}

export interface ISecondaryOfferApi {
    idOffre: string;
}

export interface ITechnicalElibigilityApi {
    caracteristiqueRaccordementFTTH: ICharacteristicConnectionFTTHApi;
    offresRaccordement: IConnectionOfferApi[];
}

export interface Troncon {
    calibre: number;
}

export interface ICharacteristicConnectionFTTHApi {
    accordGestionnaireImmeubleNecessaire: boolean;
    adresse: ICharacteristicConnectionAddressFTTHApi;
    categorieRaccoLogement: string;
    groupeCategorieRaccoLogement: string;
    idPM: string;
    oi: string;
    typeEmplacementPM: string;
    typeImmeuble: string;
    typeZone: string;
    technologiesPON: PONTECHNOLOGY[];
}

export interface ICharacteristicConnectionAddressFTTHApi {
    _type: string;
    codeINSEE: string;
    codePostal: string;
    codeRivoli: string;
    commune: string;
    hexaCleInterne: string;
    idAdresseByTel: string;
    imb: string;
    numero: string;
    voie: string;
    batiment?: string;
    etage?: string;
    escalier?: string;
    complementNumero?: string;
}

export interface IConnectionOfferApi {
    caracteristiqueTechnique: ITechnicalCharacteristicApi;
    dateAcceptationCommande?: Date;
    dateOuvertureCommerciale: Date;
    faisabilite: Faisabilite;
    idOffreLegacy: string;
    idOffreRaccordement: string;
    alertes?: Alerte[];
}

export interface Alerte {
    code: string;
    libelle: string;
}

export interface ITechnicalCharacteristicApi {
    _type: Type;
    debitDownMaxTheorique: number;
    debitUpMaxTheorique: number;
    ligneDeMarche: MarketLine;
    technologie: TechnologyType;
    typeTechno: TechnoType;
    zoneTarifaire: string;
    reseauCollecte?: string;
}

export interface ILocalisationApi {
    adresse: ICharacteristicConnectionAddressFTTHApi;
    pointAcces: AccessPointApi;
}

export interface AccessPointApi {
    ND: string;
    NDRoutage: string;
    idRaccordement: string;
    pto: string;
    statut: string;
    statutAccesDSL: string;
    statutAccesFTTH: string;
}


export enum Type {
    CaracteristiqueTechnique = 'CaracteristiqueTechnique',
}

export enum MarketLine {
    Fai = 'FAI',
}

export enum TechnoType {
    FTTH = 'FTTH',
    XDSL = 'XDSL',
}

export enum TechnologyType {
    ADSL = 'ADSL',
    VDSL = 'VDSL',
}

export enum Faisabilite {
    F0 = 'F0',
}

export enum PONTECHNOLOGY {
    GPON = 'GPON',
    XGSPON = 'XGSPON',
}